import { OrderLineModel } from "@insite/client-framework/Types/ApiModels";

export const getOrderIsPurchasableOnWebOverall = (orderLines: OrderLineModel[] | null | undefined) => {
    let result = true;
    if (orderLines === undefined || orderLines === null || orderLines?.length === 0) {
        result = true;
    } else {
        orderLines.forEach(orderLine => {
            if (orderLine.properties !== undefined) {
                if (orderLine.properties.nonPurchasableOnWeb !== undefined) {
                    if (orderLine.properties.nonPurchasableOnWeb.toLowerCase() === "true") {
                        result = false;
                    }
                }
            }
        });
    }

    return result;
};

export const getOrderIsDiscontinuedOverall = (orderLines: OrderLineModel[] | null | undefined) => {
    let result = false;

    if (orderLines === undefined || orderLines === null || orderLines?.length === 0) {
        result = false;
    } else {
        orderLines.forEach(orderLine => {
            if (orderLine.properties !== undefined) {
                if (orderLine.properties.discontinuedStatus !== undefined) {
                    if (orderLine.properties.discontinuedStatus.toLowerCase() === "discontinued") {
                        result = true;
                    }
                }
            }
        });
    }

    return result;
};

export const getOrderIsTempNotForSaleOverall = (orderLines: OrderLineModel[] | null | undefined) => {
    let result = false;

    if (orderLines === undefined || orderLines === null || orderLines.length === 0) {
        result = false;
    } else {
        orderLines.forEach(orderLine => {
            if (orderLine.properties !== undefined) {
                if (orderLine.properties.discontinuedStatus !== undefined) {
                    if (orderLine.properties.discontinuedStatus.toLowerCase() === "temp not for sale") {
                        result = true;
                    }
                }
            }
        });
    }

    return result;
};
